import { render, staticRenderFns } from "./InsuranceCompanyServices.vue?vue&type=template&id=b13baf22&"
import script from "./InsuranceCompanyServices.vue?vue&type=script&lang=js&"
export * from "./InsuranceCompanyServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports